import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Divider, TextField, MenuItem, CircularProgress, Grid, Card, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, } from '@mui/material';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import axios from "axios";

import creditcardimg from './../assets/images/Dummycreditcard2.png'
import EditIcon from '@mui/icons-material/Edit';
const MyCardDetails2 = () => {
    document.title = "Avatar Chatbots - My Card Details"
    const [openModal, setOpenModal] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { register, handleSubmit, formState: { errors, }, setError, trigger, } = useForm({});
    const [updatecard, setupdatecard] = useState(false)
    const userinfo = JSON.parse(sessionStorage.getItem('user-info'))
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search.slice(1));
    let obj = {};
    for (let pair of params.entries()) {
        obj[pair[0]] = pair[1]
    }
    const [carddetails, setcarddetails] = useState({})
    const getyourcardDetails = () => {
        axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
        axios.get(`/apiV1/get-card-details/?user_id=${userinfo.id}`).then((res) => {
            if (res.data) {
                setcarddetails(res.data)
            }


        }).catch((e) => {  if(e.response.data.message){
            seterrormes(e.response.data.message)
        } });
    }
    useEffect(() => {
        getyourcardDetails()
    }, [])
    const [errormes, seterrormes]= useState()
    const signUpAction = (data) => {
        seterrormes("")
        setIsSubmitting(true)
        let req = {
            card_number: data.card_number,
            expiry: data.expiry_year + "-" + data.expiry_month,
            card_code: data.CVV,
            sub_id: carddetails.subscription_id
        }
        axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
        axios.post(`/apiV1/update-card-details/`, req).then((rep) => {
            setIsSubmitting(false)
            setOpenModal(true)

        }
        ).catch((e) => {
            seterrormes(e.response.data.message)
            setIsSubmitting(false)

        })
    }
    return (
        <>
            {isSubmitting && (
                <div className="screenLoader" style={{ height: "85vh" }}>
                    <div className='text-center' style={{ marginTop: "10%" }}>
                        <div className='spinner-grow text-primary' role='status'>
                            <span className='sr-only'>Loading...</span>
                        </div>
                    </div>
                </div>
            )}

            <Box component="form" onSubmit={handleSubmit(signUpAction)} noValidate sx={{ mt: 1, pt: 5 }} >
                <Grid container spacing={7}>
                    <Grid item xs={12} lg={6} >

                        <Card className='positionre' >
                            <Box textAlign={"center"}>
                                <Typography variant='h4'>Card Details</Typography>
                            </Box>

                            <Box textAlign={"center"} sx={{ m: 4 }}>
                                <div className='positionre' style={{ display: "inline-block" }}>
                                    <img src={creditcardimg} alt="credit card" />

                                    <span className='cardnumber'>{carddetails.card_number ? carddetails.card_number.slice(-4) : "0000"}</span>
                                </div>


                                <div role='button' className='carddetailsedit' onClick={() => setupdatecard(!updatecard)}><EditIcon /></div>
                            </Box>

                            {updatecard ?
                                <Grid container spacing={{ lg: 2 }} sx={{ p: 3 }}>
                                    <Grid item lg={12} >
                                        <label htmlFor="card_number" mt={3} mb={1}>Card Number </label>
                                        <input type="text" className="form-control" id="card_number" placeholder="Card number" maxLength={16} {...register("card_number", {
                                            required: "This field is required",
                                            pattern: {
                                                value: /^[0-9]+$/,
                                                message: "Please enter a card number",
                                            },
                                            minLength: {
                                                value: 16,
                                                message: "Please enter min 16 characters ",
                                            },
                                            maxLength: {
                                                value: 19,
                                                message: "Please enter min 19 characters ",
                                            },

                                        })}
                                            onKeyUp={() => {
                                                trigger("card_number");

                                            }} />
                                        {errors.card_number && (<small className='text-danger font-bold'> {errors.card_number.message} </small>)}

                                    </Grid>
                                    <Grid item lg={4}>
                                        <label htmlFor="expiry_month" mt={1} mb={1}>Expiry Month</label>


                                        <select className="form-select" id="expiry_month"   {...register("expiry_month", { required: "Please select Expiry Month ", })}
                                            onKeyUp={() => { trigger("expiry_month"); }}
                                            onChange={() => {
                                                if (errors.expiry_month) {
                                                    setError("expiry_month", { type: "custom", message: "" });
                                                }
                                            }} >
                                            <option value=''>Select Month</option>
                                            <option value='01'>Jan</option>
                                            <option value='02'>Feb</option>
                                            <option value='03'>Mar</option>
                                            <option value='04'>Apr</option>
                                            <option value='05'>May</option>
                                            <option value='06'>June</option>
                                            <option value='07'>Jul</option>
                                            <option value='08'>Aug</option>
                                            <option value='09'>Sep</option>
                                            <option value='10'>Oct</option>
                                            <option value='11'>Nov</option>
                                            <option value='12'>Dec</option>

                                        </select>

                                        {errors.expiry_month && (<small className='text-danger font-bold'> {errors.expiry_month.message} </small>)}

                                    </Grid>
                                    <Grid item lg={4}>
                                        <label htmlFor="expiry_year" mt={1} mb={1}>Expiry Year  </label>
                                        <select className="form-select" id="expiry_year"   {...register("expiry_year", { required: "Please select expiry year", })}
                                            onKeyUp={() => { trigger("expiry_year"); }}
                                            onChange={() => {
                                                if (errors.expiry_year) {
                                                    setError("expiry_year", { type: "custom", message: "" });
                                                }
                                            }}>
                                            <option value=''>Select Year</option>
                                            <option value='2024'>2024</option>
                                            <option value='2025'>2025</option>
                                            <option value='2026'>2026</option>
                                            <option value='2027'>2027</option>
                                            <option value='2028'>2028</option>
                                            <option value='2029'>2029</option>
                                            <option value='2030'>2030</option>
                                            <option value='2031'>2031</option>
                                            <option value='2032'>2032</option>
                                            <option value='2033'>2033</option>
                                            <option value='2034'>2034</option>
                                            <option value='2035'>2035</option>
                                            <option value='2036'>2036</option>
                                            <option value='2037'>2037</option>
                                            <option value='2038'>2038</option>
                                            <option value='2039'>2039</option>
                                            <option value='2040'>2040</option>

                                        </select>

                                        {errors.expiry_year && (<small className='text-danger font-bold'> {errors.expiry_year.message} </small>)}

                                    </Grid>
                                    <Grid item lg={4}>
                                        <label htmlFor="CVV" mt={1} mb={1}>CVV</label>
                                        <input type="number" className="form-control" id="CVV" placeholder="CVV" {...register("CVV", {
                                            required: "This field is required",
                                            pattern: {
                                                value: /^[0-9]+$/,
                                                message:
                                                    "Please enter min and max 3 digits",
                                            },
                                            minLength: {
                                                value: 3,
                                                message: "Please enter min and max 3 characters ",
                                            },
                                            maxLength: {
                                                value: 3,
                                                message: "Please enter min and max 3 characters ",
                                            }
                                        })}
                                            onKeyUp={() => {
                                                trigger("CVV");

                                            }} />
                                        {errors.CVV && (<small className='text-danger font-bold'> {errors.CVV.message} </small>)}

                                    </Grid>
                                    <Grid item lg={12} >
                                    
                                        <Box textAlign={"right"}>
                                            
                                            <button type="button" onClick={() => setupdatecard(!updatecard)} style={{ height: "40px", width: "initial", background: " linear-gradient(to right,rgb(233, 6, 6),rgb(240, 32, 49))" }} disabled={isSubmitting} className="position-relative d-inline-flex align-items-center justify-content-center p-1  me-2 overflow-hidden text-sm greaditentbutton fw-medium text-dark rounded-lg border-0" >
                                                <span className="position-relative px-4 py-2  rounded-md" style={{ transition: "0.3s" }} >Cancel</span>
                                            </button>
                                            {isSubmitting && (
                                                <CircularProgress disabled style={{ height: '30px', width: '30px', textAlign: "center" }} />
                                            )}
                                            <button type="submit" style={{ height: "40px", width: "initial" }} className="position-relative d-inline-flex align-items-center justify-content-center p-1  me-2 overflow-hidden text-sm greaditentbutton fw-medium text-dark rounded-lg border-0" >
                                                <span className="position-relative px-4 py-2  rounded-md" style={{ transition: "0.3s" }} > Update Credit Card </span>
                                            </button>

                                        </Box>
                                    </Grid>

                                </Grid> : ""}
                                <div className="text-danger px-4 pb-5">{errormes}</div>
                        </Card>
                    </Grid>

                </Grid>

            </Box>
            <Dialog open={openModal} onClose={() => setOpenModal(false)} disableEscapeKeyDown onBackdropClick >
                <DialogTitle>Card Details</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Your card details updated successfully
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" component={Link}
                        to={`/planing`} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
export default MyCardDetails2;
